import { ProgressView } from '@findigs/ui-kit/src/components/progress-view';
import { useLocation, useNavigation } from '@remix-run/react';
import { useEffect, useState } from 'react';
import { loadingIndicatorStyles } from './global-loading-indicator.module.scss';

const LOADING_DELAY_MS = 400;

/**
 * Global loading indicator that shows during navigation between routes.
 *
 * Displays loading indicator only after a threshold time to avoid
 * flickering for fast page loads, providing consistent UX across the app.
 *
 * Note: Only shows when navigating to a different route. Does not appear
 * during form submissions or when revalidating the current route.
 */
export function GlobalLoadingIndicator() {
  const navigation = useNavigation();
  const location = useLocation();
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    const isNavigatingAway =
      navigation.state === 'loading' &&
      navigation.location?.pathname !== location.pathname;

    let timeoutId: NodeJS.Timeout;

    if (isNavigatingAway) {
      timeoutId = setTimeout(() => {
        setShowLoading(true);
      }, LOADING_DELAY_MS);
    } else {
      setShowLoading(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [navigation.state, navigation.location?.pathname, location.pathname]);

  return (
    <ProgressView loading={showLoading} className={loadingIndicatorStyles} />
  );
}
